import { useTheme } from "../hooks/useTheme";
import { Code, Gamepad2, Link, Smartphone, Palette, Zap } from "lucide-react";

const Services = () => {
  const { isDarkMode } = useTheme();

  const services = [
    {
      icon: Code,
      title: "Web Development",
      description:
        "Modern, responsive web applications built with React, Node.js, and the latest technologies. Fast, scalable, and user-friendly solutions.",
    },
    {
      icon: Gamepad2,
      title: "Game Development",
      description:
        "Interactive games and gamified experiences using Godot, JavaScript, and WebGL. From simple browser games to complex multiplayer experiences.",
    },
    {
      icon: Link,
      title: "Web3 Solutions",
      description:
        "Decentralized applications, smart contracts, and blockchain integrations. Building the future of the internet with cutting-edge Web3 technologies.",
    },
    {
      icon: Smartphone,
      title: "Mobile Apps",
      description:
        "Cross-platform mobile applications using React Native and modern development frameworks. Native performance, universal reach.",
    },
    {
      icon: Palette,
      title: "UI/UX Design",
      description:
        "Intuitive user interfaces and engaging user experiences. From wireframes to polished designs that users love to interact with.",
    },
    {
      icon: Zap,
      title: "Performance Optimization",
      description:
        "Speed up your applications and improve user engagement. Code optimization, database tuning, and infrastructure improvements.",
    },
  ];

  return (
    <section
      id="services"
      className="py-16 sm:py-20 md:py-24 lg:py-28 relative"
      aria-labelledby="services-heading"
    >
      <div className="w-full px-4 sm:px-6 md:px-8 lg:px-12 xl:px-16 2xl:px-20 relative z-10">
        <header className="w-full text-center mb-12 sm:mb-16 block">
          <h2
            id="services-heading"
            className={`text-3xl sm:text-4xl lg:text-5xl font-bold mb-4 w-full transition-colors duration-700 ${
              isDarkMode ? "text-white" : "text-graphite-darkest"
            }`}
          >
            Professional Development Services
          </h2>
          <p
            className={`text-lg sm:text-xl lg:text-2xl max-w-4xl mx-auto w-full transition-colors duration-700 ${
              isDarkMode ? "text-gray-200" : "text-graphite-medium"
            }`}
          >
            From pixel-perfect web applications to blockchain architecture, we
            transform ideas into powerful digital realities. Expert developers
            delivering custom solutions.
          </p>
        </header>

        <div
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 sm:gap-10 lg:gap-12 w-full mt-12"
          role="list"
        >
          {services.map((service, index) => {
            return (
              <article key={index} className="text-center p-4" role="listitem">
                <div
                  className={`mb-4 sm:mb-6 flex justify-center items-center ${
                    isDarkMode ? "text-white" : "text-graphite-darkest"
                  }`}
                  aria-hidden="true"
                >
                  <service.icon
                    size={48}
                    className="w-12 h-12 sm:w-14 sm:h-14 lg:w-16 lg:h-16"
                  />
                </div>

                <h3
                  className={`text-lg sm:text-xl lg:text-2xl font-semibold mb-3 sm:mb-4 transition-colors duration-700 ${
                    isDarkMode ? "text-white" : "text-graphite-darkest"
                  }`}
                >
                  {service.title}
                </h3>

                <p
                  className={`text-sm sm:text-base lg:text-lg leading-relaxed transition-colors duration-700 ${
                    isDarkMode ? "text-gray-200" : "text-graphite-medium"
                  }`}
                >
                  {service.description}
                </p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
